import { IS_ONE_OF, IS_NOT_ONE_OF } from 'utils/comparatorTypes';
import { isIsOneOfComparator } from './isIsOneOfComparator';
import { isNotOneOfComparator } from './isNotOneOfComparator';

export const getComparatorValue = ({
  value: comparator,
  ...rest
}: {
  value: string;
  values?: string[];
  field: string;
  isMultiSelectInputAllowed: boolean;
  isMultiSelectWithListMembershipAllowed: boolean;
}) => {
  if (isIsOneOfComparator({ value: comparator, ...rest })) {
    return IS_ONE_OF;
  } else if (isNotOneOfComparator({ value: comparator, ...rest })) {
    return IS_NOT_ONE_OF;
  }
  return comparator;
};
